import { BaseModal } from '../../../../../../components/Toolkit/Modal/BaseModal';
import { Button } from '../../../../../../components/Toolkit/Button';
import * as Styled from '../../../../../../components/PageWrappers/AdDetails/components/CarSummary/InfoModal/InfoModal.styled';
import type { InfoModalProps } from '../../../../../../components/PageWrappers/AdDetails/components/CarSummary/InfoModal/InfoModal.typed';

const InfoModal = (props: InfoModalProps) => {
  const { isOpen, askToClose, title, buttonText, testId, children } = props;

  return (
    <BaseModal askToClose={askToClose} isOpen={isOpen} testId={testId}>
      <Styled.Title>{title}</Styled.Title>
      <Styled.Body>{children}</Styled.Body>
      <Button onClick={askToClose}>{buttonText}</Button>
    </BaseModal>
  );
};

export default Object.assign(InfoModal, {
  Text: Styled.Text,
});
